var map = {
	"./1000palabraslogo.png": 9962,
	"./4enrayalogo.png": 9215,
	"./QuarzoLetters.png": 691,
	"./ahorcadologo.png": 9282,
	"./anagramaslogo.png": 9204,
	"./arquitectologo.png": 7578,
	"./asciilogo.png": 3470,
	"./briscalogo.png": 7777,
	"./briscanuevalogo.png": 6576,
	"./chinchonlogo.png": 535,
	"./crucigramaslogo.png": 8702,
	"./escoba2024logo.png": 1076,
	"./escobalogo.png": 4192,
	"./españa.png": 8199,
	"./googleplaypass.png": 6864,
	"./logo.png": 2077,
	"./logointro.png": 2431,
	"./mandalasantiguologo.png": 7097,
	"./mandalaslogo.png": 954,
	"./smalllogo.png": 9698,
	"./solitarios25logo.png": 6805,
	"./solitarioslogo.png": 7818,
	"./sopaletraslogo.png": 1561,
	"./sopalogo.png": 6506,
	"./sopaonlinelogo.png": 4643,
	"./spinnerlogo.png": 5984,
	"./sudokulogo.png": 449,
	"./textartlogo.png": 6735,
	"./uk.png": 8480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1215;